import resso from "resso";

const stationStore = resso({
  searchAddress: "",
  searchAddressLatLng: [],
  filteredStationZones: [],
  placeId: "",
  modelListSortBy: "default", // default, sortFromLow, sortFromHigh
  priceListSortBy: "sortFromLow", // priceFromLow, priceFromHigh
  carTypeFilter: [],
  powerFilter: [],
  insuranceFilter: [],
  seatsFilter: [],
  listLoading: true,
  hasSpecialModel: false,
  specialModel: "",
});

export default stationStore;
